import { get, post, put, destroy } from "./axiosClient";

const managementService = {
  //USER MANAGEMENT
  getUserList: (groupId, searchKeyword, limit, offset) =>
    get(
      `/user/list?groupId=` +
        groupId +
        `&searchKeyword=` +
        searchKeyword +
        `&limit=` +
        limit +
        `&offset=` +
        offset
    ),
  getLastUserList: (limit, offset) =>
    get(`/user/lastRegisterUsers?limit=` + limit + `&offset=` + offset),
  getUserListWithExcludedUserIds: (
    groupId,
    searchKeyword,
    limit,
    offset,
    body
  ) =>
    post(
      `/user/list?groupId=` +
        groupId +
        `&searchKeyword=` +
        searchKeyword +
        `&limit=` +
        limit +
        `&offset=` +
        offset,
      body
    ),
  getUser: (userId) => get(`/user/get/` + userId),
  searchUser: (filter) => post(`/user/search`, filter),
  createUser: (user) => post(`/user`, user),
  editUser: (user) => put(`/user`, user),
  deleteAllUsers: (ids) => post(`/user/deleteAll`, ids),
  setProfile: (user) => post(`/user/profile`, user),
  sendVerificationEmail: (email, language) =>
    post(`/user/verify?lang=` + language, email),
  register: (registerBody) => post(`/user/register`, registerBody),
  sendPasswordEmail: (email, language) =>
    post(`/user/password?lang=` + language, email),

  //USER GROUP MANAGEMENT
  getUserGroupList: (searchKeyword, limit, offset) =>
    get(
      `/group/list?searchKeyword=` +
        searchKeyword +
        `&limit=` +
        limit +
        `&offset=` +
        offset
    ),
  getUserGroupListById: (groupId) => get(`/group/` + groupId),
  createUserGroup: (userGroup) => post(`/group`, userGroup),
  editUserGroup: (userGroup) => put(`/group`, userGroup),
  deleteAllUserGroups: (ids) => post(`/group/deleteAll`, ids),

  //MEETING MANAGEMENT
  getMeeting: (id) => get(`/meeting/` + id),
  getMeetingList: (filter) => post(`/meeting/list`, filter),
  createMeeting: (meeting) => post(`/meeting`, meeting),
  editMeeting: (meeting) => put(`/meeting`, meeting),
  deleteAllMeetings: (ids) => post(`/meeting/deleteAll`, ids),

  //LDAP MANAGEMENT
  getLdapList: () => get(`/ldap/list`),
  createLdap: (ldapSettings) => post(`/ldap`, ldapSettings),
  editLdap: (ldapSettings) => put(`/ldap`, ldapSettings),
  deleteAllLdap: (ids) => post(`/ldap/deleteAll`, ids),
  checkLdap: (ldapSettings) => post(`/ldap/check`, ldapSettings),
  syncLdap: (params) => post(`/ldap/sync`, params, { timeout: 60000 * 30 }),
  deleteImportedUsers: (params) => post(`/ldap/deleteImportedUsers`, params),
};

export default managementService;
